import React from 'react'
import useJobLogs from '../../../hooks/use-job-logs'
import { groupBy, sortBy } from 'lodash'
import { Accordion, Card, Button } from 'react-bootstrap'
import { JsonTable } from 'react-json-to-html'

const JobLogs = ({
    job = {},
}) => {

    const { jobLogs } = useJobLogs({ jobId: job.id, limit: 10 })
    const groupedLogs = groupBy(jobLogs, 'createdDate')

    const renderLog = (log) => (<JsonTable key={log.id} json={log.content} />)

    const renderGroup = (logs, key) => {
        logs = sortBy(logs, 'id' )
        return (
            <Accordion key={key}>
                <Card>
                    <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey={key}>
                            {key}
                        </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey={key}>
                        <Card.Body>
                            {logs.map(renderLog)}
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        )
    }

    return (
        <div>
            {Object.keys(groupedLogs).map(key => renderGroup(groupedLogs[key], key))}
        </div>
    )
}

export default JobLogs